import { render } from "./modal-bottom-gold-onboard.html?vue&type=template&id=1936cdff&scoped=true&ts=true"
import script from "./modal-bottom-gold-onboard.vue?vue&type=script&lang=ts"
export * from "./modal-bottom-gold-onboard.vue?vue&type=script&lang=ts"

import "./modal-bottom-gold-onboard.scss?vue&type=style&index=0&id=1936cdff&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1936cdff"]])

export default __exports__